import TitleColumn from "./TitleColumn";

export default TitleColumn;
